const fund = {
  id: 0,
  cnpj: '',
  legal_name: '',
  label: '',
  asset_manager: '',
  status: '',
  code_originator: '',
  vortx_url: '',
  vortx_handshake: '',
  bank_code: '',
  ag: '',
  cc: '',
  ag_code: '',
  cc_code: ''
}

const errors = {
  infos: []
}

export default {
  initialFund: { ...fund },
  fund: { ...fund },
  initialErrors: { ...errors },
  errors: { ...errors },
  list: []
}



// WEBPACK FOOTER //
// ./src/features/funds/store/state.js